export const LEFT_SERVICES = [
  // {
  //   name: 'Hot Stone Application',
  //   description:
  //     'Heated basalt stones are placed and worked across the body, driving warmth into deep muscle tissue and settling the nervous system.',
  // },
  {
    name: 'Deep Tissue & Myofascial Work',
    description:
      'Slow, sustained pressure reaches the deeper layers of muscle and connective tissue, releasing chronic tension and restrictions.',
  },
  {
    name: 'Kinesiotaping',
    description:
      'Flexible elastic tape gently elevates skin layers to stimulate circulatory flow, easing tension and reinforcing fatigued muscles.',
  },
];

export const RIGHT_SERVICES = [
  // {
  //   name: 'Cupping',
  //   description:
  //     'Suction cups lift soft tissue to encourage fluid movement, relieving adhesions and decompressing overworked muscles.',
  // },
  {
    name: 'Assisted Stretching',
    description:
      'Your therapist guides each stretch to the end of your comfortable range, improving mobility.',
  },
  {
    name: 'Trigger Point Therapy',
    description:
      'Concentrated pressure on hyperirritable muscle spots interrupts the pain-spasm cycle at its source, to resolve referred pain patterns.',
  },
];

export const ALL_SERVICES = [...LEFT_SERVICES, ...RIGHT_SERVICES];
